(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-hero-new"] && !Shopify.designMode) return;
  try {
    
  class VideoController {
    constructor(videoElement, playPauseButton) {
      this.video = videoElement;
      this.button = playPauseButton;
      // Initialize state based on the actual video element
      this.isPlaying = !this.video.paused;

      // Listen for button clicks
      this.button.addEventListener('click', () => this.togglePlayPause());

      // Listen for native video events to sync external pauses (like playing another video)
      this.video.addEventListener('play', () => {
        this.isPlaying = true;
        this.updateButtonState();
      });

      this.video.addEventListener('pause', () => {
        this.isPlaying = false;
        this.updateButtonState();
      });

      this.updateButtonState();
    }

    togglePlayPause() {
      // Let the native event listeners handle the state update
      if (this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
    }

    updateButtonState() {
      const iconName = this.isPlaying ? 'pause' : 'play';
      if (iconName === 'pause') {
        this.button.querySelector(
          '.icon'
        ).innerHTML = `<svg class="" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-label="Pause"><path fill="#ffffff" d="m2 1v22h7v-22zm13 0v22h7v-22z"></path></svg>`;
      } else {
        this.button.querySelector(
          '.icon'
        ).innerHTML = `<svg class="" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-label="Play"><path fill="#ffffff" d="m22 12-20 11v-22l10 5.5z"></path></svg>`;
      }
      this.button.setAttribute('aria-label', `${this.isPlaying ? 'Pause' : 'Play'} video`);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const desktopVideo = document.querySelector('.desktop-media video');
    const mobileVideo = document.querySelector('.mobile-media video');
    const desktopButton = document.querySelector('.desktop-media .video-control');
    const mobileButton = document.querySelector('.mobile-media .video-control');

    if (desktopVideo && desktopButton) {
      new VideoController(desktopVideo, desktopButton);
    }
    if (mobileVideo && mobileButton) {
      new VideoController(mobileVideo, mobileButton);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-old-search-style"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
  if (this.headerIsAlwaysSticky) return;
  this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  this.closeMenuDisclosure();
  // this.closeSearchModal();

  // Add "shopify-section-header-hidden" class to all elements with class "drtvNav"
  const drtNavElements = document.querySelectorAll('.drtvNav.mobile--only');
  drtNavElements.forEach(element => {
    element.classList.add('shopify-section-header-hidden');
  });

  // Add "scroll-down" class to body and remove "scroll-up"
  document.body.classList.add('scroll-down');
  document.body.classList.remove('scroll-up');
}

reveal() {
  if (this.headerIsAlwaysSticky) return;
  this.header.classList.add('shopify-section-header-sticky', 'animate');
  this.header.classList.remove('shopify-section-header-hidden');

  // Remove "shopify-section-header-hidden" class from all elements with class "drtvNav"
  const drtNavElements = document.querySelectorAll('.drtvNav.mobile--only');
  drtNavElements.forEach(element => {
    element.classList.remove('shopify-section-header-hidden');
  });

  // Add "scroll-up" class to body and remove "scroll-down"
  document.body.classList.add('scroll-up');
  document.body.classList.remove('scroll-down');
}

reset() {
  if (this.headerIsAlwaysSticky) return;
  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

  // Remove "shopify-section-header-hidden" class from all elements with class "drtvNav"
  const drtNavElements = document.querySelectorAll('.drtvNav.mobile--only');
  drtNavElements.forEach(element => {
    element.classList.remove('shopify-section-header-hidden');
  });

  // Remove both "scroll-up" and "scroll-down" classes from body
  document.body.classList.remove('scroll-up', 'scroll-down');
}

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    /* closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    } */
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

     setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    } 

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
  if (this.headerIsAlwaysSticky) return;
  this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  this.closeMenuDisclosure();
  // this.closeSearchModal();

  // Add "shopify-section-header-hidden" class to all elements with class "drtvNav"
  const drtNavElements = document.querySelectorAll('.drtvNav.mobile--only');
  drtNavElements.forEach(element => {
    element.classList.add('shopify-section-header-hidden');
  });

  // Add "scroll-down" class to body and remove "scroll-up"
  document.body.classList.add('scroll-down');
  document.body.classList.remove('scroll-up');
}

reveal() {
  if (this.headerIsAlwaysSticky) return;
  this.header.classList.add('shopify-section-header-sticky', 'animate');
  this.header.classList.remove('shopify-section-header-hidden');

  // Remove "shopify-section-header-hidden" class from all elements with class "drtvNav"
  const drtNavElements = document.querySelectorAll('.drtvNav.mobile--only');
  drtNavElements.forEach(element => {
    element.classList.remove('shopify-section-header-hidden');
  });

  // Add "scroll-up" class to body and remove "scroll-down"
  document.body.classList.add('scroll-up');
  document.body.classList.remove('scroll-down');
}

reset() {
  if (this.headerIsAlwaysSticky) return;
  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

  // Remove "shopify-section-header-hidden" class from all elements with class "drtvNav"
  const drtNavElements = document.querySelectorAll('.drtvNav.mobile--only');
  drtNavElements.forEach(element => {
    element.classList.remove('shopify-section-header-hidden');
  });

  // Remove both "scroll-up" and "scroll-down" classes from body
  document.body.classList.remove('scroll-up', 'scroll-down');
}

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    /* closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    } */
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
